import { useCallback } from 'react';
import { FD161 } from '../../../services/d206Api';

/**
 * D206 金額計算 hook (BR-05)
 *
 * - fd161_22 = ROUND(fd161_15 * fd161_14, 0)  退出金額
 * - fd160_14 = SUM(fd161_15)                    總退回數量
 * - fd160_16 = SUM(fd161_22)                    未稅退貨總額
 * - fd160_22 = ROUND(fd160_16 * 0.05, 0)        退貨總稅額
 * - 含稅退貨總金額(顯示用) = fd160_16 + fd160_22
 */
export function useD206Calculation() {
  /** Recalculate a single detail row's amount */
  const calcDetailAmount = useCallback((detail: Partial<FD161>): number => {
    const qty = detail.fd161_15 || 0;
    const price = detail.fd161_14 || 0;
    return Math.round(qty * price);
  }, []);

  /** Recalculate all summary fields from details */
  const calcSummary = useCallback((details: Partial<FD161>[]): {
    totalQty: number;
    totalAmount: number;
    taxAmount: number;
    totalWithTax: number;
  } => {
    let totalQty = 0;
    let totalAmount = 0;

    for (const d of details) {
      totalQty += d.fd161_15 || 0;
      // Re-derive row amount for consistency
      const rowAmt = Math.round((d.fd161_15 || 0) * (d.fd161_14 || 0));
      totalAmount += rowAmt;
    }

    const taxAmount = Math.round(totalAmount * 0.05);
    const totalWithTax = Math.round(totalAmount + taxAmount);

    return { totalQty, totalAmount, taxAmount, totalWithTax };
  }, []);

  return { calcDetailAmount, calcSummary };
}
